import { create } from 'zustand';

export interface ImagePreviewItem {
  name: string;
  type?: string;
  url: string;
  thumbnails?: string[];
  createdAt?: number;
}

interface ImagePreviewStoreState {
  images: ImagePreviewItem[];
}

export interface ImagePreviewStoreActions {
  show(images: ImagePreviewItem[]): void;
  hide(): void;
}

type ImagePreviewStore = ImagePreviewStoreState & ImagePreviewStoreActions;

const initialState: ImagePreviewStoreState = {
  images: [],
};

export const useImagePreviewStore = create<ImagePreviewStore>()((set) => ({
  ...initialState,
  show: (images) => set(() => ({ images })),
  hide: () => set(() => initialState),
}));
